import { useCallback } from 'react'
import { resolveIcloudLogin } from 'src/utils/icloudLoginResult'

/**
 * iCloud 登录返回「密码不对」时，让用户退回「输入账号密码」那一步重填。
 *
 * 规则本身在 src/utils/icloudLoginResult.js（纯函数，可单测）；这里只负责把它接到组件状态上。
 *
 * ⚠️ 仅适用于 iOS / iCloud 登录流程。Android 走 android-auth，不会返回 10003，
 *    所以 android/ 下的弹窗（android/login、android/settings-bind-device、SyncProgress/android-cloud）不要接这个 hook。
 *
 * 两种情况不重复处理（2026-09-23 与用户确认）：
 * 1. 已经停在「输入账号密码」那一步（current === 0）；
 * 2. 被锁 / 重新验证弹窗正在显示（用户已经在那套弹窗里输密码，再退回会叠两层界面）。
 *
 * @returns {(ec: number) => boolean} true = 本次已退回「输入账号密码」那一步
 */
const useIcloudCredentialReverify = ({ current, setCurrent, lockedFlowOpen = false }) =>
  useCallback(
    ec => {
      const { type } = resolveIcloudLogin({ ec }, { step: current, lockedFlowOpen })

      if (type !== 'reenterPassword') return false
      setCurrent(0)

      return true
    },
    [current, lockedFlowOpen, setCurrent]
  )

export default useIcloudCredentialReverify
